import CityPageTemplate from "../city-template/CityPageTemplate";
import { seattleConfig } from "./data";

export default function SeattlePage() {
  return (
    <>
      <CityPageTemplate config={seattleConfig} />
    </>
  );
}